const section1 = 'sections/section1.png';
const section2 = 'sections/section2.png';
const section3 = 'sections/section3.png';
const section4 = 'sections/section4.png';
const section5 = 'sections/section5.png';

const testingContent = {
  bannerText: {
    heading: 'GAINSS: Accelerate Quality, Elevate Testing',
    items: [
      {
        title: 'From Testing to Business Value',
        info: 'Prioritize what matters with risk-based insights and production-driven testing strategies.',
        component: 'One',
      },
      {
        title: 'Automation without Limits',
        info: 'Native CI/CD integrations for effortless execution and scaling of automated tests.',
        component: 'Two',
      },
      {
        title: 'Smarter Decisions, Faster',
        info: 'Advanced analytics and predictive dashboards that empower your team to deliver quality at speed.',
        component: 'Three',
      },
      {
        title: 'Collaboration at Its Core',
        info: 'Break silos with real-time workflows connecting your entire team - developers, testers, and product owners.',
        component: 'Four',
      },
      {
        title: 'One Platform for Every Need',
        info: 'Manual, automated, and exploratory testing - unified and scalable for enterprises.',
        component: 'Five',
      },
    ],
    ctaText: 'Book a Demo',
    ctaLink: 'https://calendly.com/vikas-mittal',
  },
  comparisonTable: {
    title: 'Why GAINSS Outpaces Legacy Tools',
    image: require('../components/new-landing-page/table.png'),
    ctaDescription: 'Ready to experience the GAINSS advantage?',
    ctaText: 'Switch to GAINSS Today',
    ctaLink: 'https://app.gainss.ai/register',
  },
  useCases: [
    {
      id: 1,
      title: 'Optimizing Regression Testing for Large Test Suites',
      challenge:
        'An enterprise software company struggled with a large regression suite that took days to execute, delaying releases.',
      solution:
        'GAINSS analyzed historical execution data and defect patterns to prioritize tests for each sprint, reducing regression execution time by 50%.',
      outcome: 'Teams released updates faster while maintaining high quality.',
    },
    // {
    //   id: 2,
    //   title: "Enhancing Test Coverage for a New Feature Release",
    //   challenge: "A gaming company had difficulty ensuring sufficient test coverage for a complex multiplayer feature.",
    //   solution: "GAINSS used AI to suggest additional test scenarios based on the feature’s user stories and historical data. It also identified gaps in test coverage.",
    //   outcome: "The team achieved 100% coverage of high-priority scenarios, preventing major defects in production.",
    // },
    {
      id: 3,
      title: 'Managing Device Fragmentation for Mobile Testing',
      challenge:
        'A mobile app development team needed to test across hundreds of device and OS combinations but lacked an efficient way to plan and execute tests.',
      solution:
        'GAINSS automatically generated a device, OS, and browser matrix optimized for their user base, prioritizing devices based on usage analytics.',
      outcome:
        'Testing efforts were focused on key configurations, reducing unnecessary testing by 40%.',
    },
    // {
    //   id: 4,
    //   title: "Streamlining Localization Testing for Global Apps",
    //   challenge: "A global e-commerce company found it challenging to plan and execute localization tests across 20+ languages.",
    //   solution: "GAINSS automated the creation of localization execution matrices and flagged content inconsistencies using AI-powered anomaly detection.",
    //   outcome: "The team reduced planning time by 70% and ensured consistent quality across all locales.",
    // },
    {
      id: 5,
      title: 'Accelerating Defect Analysis and Resolution',
      challenge:
        'A fintech company spent significant time manually linking defects to test cases, delaying failure analysis.',
      solution:
        'GAINSS auto-associated defects with their respective test cases and generated detailed defect reports with linked user stories.',
      outcome:
        'Defect triage time was reduced by 60%, enabling faster fixes and more efficient sprints.',
    },
    // {
    //   id: 6,
    //   title: "Supporting Risk-Based Testing for Critical Applications",
    //   challenge: "A healthcare technology company needed to focus testing efforts on high-risk areas to meet compliance standards.",
    //   solution: "GAINSS identified high-risk areas using AI-driven analysis of code changes, historical defects, and critical functionality.",
    //   outcome: "Teams prioritized 80% of their efforts on the most critical test cases, ensuring compliance while reducing overall test execution time.",
    // },
    {
      id: 7,
      title: 'Scaling Automation Across Distributed Teams',
      challenge:
        'A SaaS company faced challenges integrating test automation results across multiple geographies in real time.',
      solution:
        'GAINSS provided API-driven integrations to synchronize automation results with the platform and deliver real-time updates on execution status.',
      outcome:
        'Global teams collaborated seamlessly, achieving a 70% reduction in manual result consolidation efforts.',
    },
    {
      id: 8,
      title: 'Improving Production-Relevant Testing',
      challenge:
        'A media streaming company experienced defects in production due to untested user journeys and rare device combinations.',
      solution:
        'GAINSS leveraged data from production monitoring tools to design tests that replicated real user behavior, including edge cases.',
      outcome:
        'Defects in production decreased by 35%, improving customer satisfaction.',
    },
    // {
    //   id: 9,
    //   title: "Simplifying Cross-Browser Testing for Web Applications",
    //   challenge: "A financial services company spent excessive time manually managing cross-browser compatibility testing.",
    //   solution: "GAINSS automatically created a browser matrix based on analytics of browser usage by the company’s target audience, optimizing efforts.",
    //   outcome: "The team achieved comprehensive coverage of relevant browsers, reducing manual planning time by 50%.",
    // },
    {
      id: 10,
      title: 'Automating Metrics and Reporting for Leadership',
      challenge:
        'Test managers at a logistics company spent hours consolidating test metrics to present to stakeholders.',
      solution:
        'GAINSS provided real-time dashboards with pre-built and customizable metrics, including defect trends, test coverage, and sprint progress.',
      outcome:
        'Leadership gained instant visibility into testing KPIs, and teams saved 15+ hours per sprint on reporting.',
    },
  ],
  challengesHeading: {
    main: 'Challenges',
    sub: 'in Managing Testing Lifecycles with Zephyr or TestRail',
    description:
      'Managing testing lifecycles with Zephyr or TestRail reveals challenges in efficiency, productivity, and alignment with business goals.',
  },
  challenges: [
    {
      title: 'Limited Strategic Value beyond Test Case Management',
      challenge:
        'Both tools primarily serve as test case repositories. While they allow test case creation, execution, and reporting, they don’t significantly contribute to higher-level objectives like risk management, business alignment, or customer experience improvement.',
      perspective:
        'Testing should drive business value, such as improving time-to-market, reducing customer-facing defects, and ensuring ROI. Tools like Zephyr or TestRail often lack advanced analytics or actionable insights into how testing aligns with broader organizational goals.',
    },
    {
      title: 'Poor Support for Test Automation at Scale',
      challenge:
        'Integration with CI/CD pipelines for automated testing is cumbersome, especially with TestRail. While Zephyr integrates better with Jira and some automation frameworks, it still doesn’t provide seamless execution and result visualization at scale.',
      perspective:
        'In modern DevOps environments, test automation is critical. Tools should natively support execution, monitoring, and reporting of automated tests across diverse pipelines. A lack of robust automation support limits the team’s ability to implement continuous testing effectively.',
    },
    {
      title: 'Inefficiencies in Test Data and Environment Management',
      challenge:
        'Neither Zephyr nor TestRail offers strong capabilities for managing test data or provisioning test environments. Testers often rely on external tools or manual processes, leading to inefficiencies and delays.',
      perspective:
        'Effective test data management and environment provisioning are critical for minimizing bottlenecks. Testing tools that fail to integrate with data management or environment-as-code solutions don’t support the infrastructure requirements of modern, scalable testing.',
    },
    {
      title: 'Limited AI/ML-Powered Insights and Predictive Analytics',
      challenge:
        'The tools lack AI/ML capabilities for smarter test management, such as recommending high-risk areas to focus on, predicting defects, or optimizing test coverage.',
      perspective:
        'Modern software development requires testing tools to leverage AI/ML for risk-based testing and better decision-making. The absence of such capabilities reduces the ability to proactively improve quality and manage risks in an agile manner.',
    },
    {
      title: 'Poor Collaboration Features Across Teams',
      challenge:
        'While Zephyr integrates well with Jira, its collaboration features are limited to basic task assignments and notifications. TestRail, as a standalone tool, requires additional steps for linking tests to development or business teams’ tasks.',
      perspective:
        'Seamless collaboration between testers, developers, and product owners is essential to eliminate silos. Tools that fail to facilitate cross-functional communication hinder agile workflows and reduce efficiency.',
    },
    {
      title: 'Lack of Real-Time Production Insights for Testing',
      challenge:
        'These tools don’t leverage insights from production monitoring tools (e.g., Dynatrace, New Relic) to prioritize testing. This leads to a disconnect between what is being tested and what users are actually experiencing.',
      perspective:
        'Testing should be informed by real-world usage patterns to improve relevance and efficiency. Tools that don’t integrate with monitoring systems miss an opportunity to enhance testing based on production data.',
    },
    {
      title: 'Reporting Limitations',
      challenge:
        'The reporting capabilities in Zephyr and TestRail are often static and lack customization. They don’t provide granular insights into metrics like defect leakage, test effectiveness, or business risk.',
      perspective:
        'Decision-making relies on actionable data. Tools that don’t offer dynamic, customizable reporting aligned with business KPIs limit visibility for leadership teams.',
    },
    {
      title: 'Overhead for Manual Test Management',
      challenge:
        'Managing large numbers of manual test cases becomes cumbersome, especially in TestRail, which lacks the simplicity and scalability testers require. Reusing or archiving test cases often involves significant effort.',
      perspective:
        'Manual test case management should be lightweight and scalable. Tools that don’t simplify this process add unnecessary operational overhead, slowing down testing teams.',
    },
  ],
  sectionButtonLink: 'https://app.gainss.ai/register',
  sectionContent: [
    {
      image: section1,
      position: 'left',
      heading: 'Revolutionizing Software Testing with AI and ML',
      info: 'At GAINSS, we bring the power of artificial intelligence (AI) and machine learning (ML) to the heart of software testing.',
      lists: [
        {
          heading: 'Smarter Test Case Design',
          info: 'Get AI-driven recommendations to design impactful and efficient test cases based on requirements, user stories, and feature changes in upcoming releases.',
        },
        {
          heading: 'Execution Suite Optimization',
          info: 'Automatically build and prioritize execution suites tailored to specific user stories, risk areas, and release features.',
        },
        {
          heading: 'Execution Matrix Recommendations',
          info: 'Plan and create test execution matrices effortlessly, optimized for devices, operating systems, browsers, and localization needs.',
        },
      ],
    },
    {
      image: section2,
      position: 'right',
      heading: 'Unmatched Planning and Execution Capabilities',
      info: 'GAINSS is built to support your end-to-end testing lifecycle with precision and scalability.',
      lists: [
        {
          heading: 'Integrated Dashboards and Metrics',
          info: 'Real-time insights into test coverage, execution progress, defect density, and more, all in one place.',
        },
        {
          heading: 'Streamlined Localization Testing',
          info: 'Simplify planning and execution for global releases with tools to manage test coverage for multiple languages, locales, and regions.',
        },
        {
          heading: 'Real-Time Updates with Automation',
          info: 'Seamlessly integrate your test automation frameworks using GAINSS-provided APIs to update execution results in real time.',
        },
      ],
    },
    {
      image: section3,
      position: 'left',
      heading: 'Empowering Faster Defect Analysis and Collaboration',
      info: 'GAINSS reduces time-to-resolution and fosters collaboration across teams with built-in intelligent features.',
      lists: [
        {
          heading: 'Defect Auto-Association',
          info: 'Automatically detect and attach defects logged against failed test cases, significantly reducing failure analysis time.',
        },
        {
          heading: 'Actionable Failure Insights',
          info: 'Generate detailed defect logs with links to related test cases and user stories, ensuring quick and effective triaging.',
        },
        {
          heading: 'Team Collaboration',
          info: 'Enable testers, developers, and managers to collaborate seamlessly using shared dashboards and traceability from requirements to defects.',
        },
      ],
    },
    {
      image: section4,
      position: 'right',
      heading: 'Designed for Engineering Leaders and Testing Teams',
      info: "Whether you're an engineering leader seeking better ROI or a test manager striving for operational excellence, GAINSS has you covered.",
      lists: [
        {
          heading: 'Improve Release Predictability',
          info: 'Gain data-driven insights to enhance release planning and execution.',
        },
        {
          heading: 'Achieve Better Test Coverage',
          info: 'Automate planning and execution matrix design to maximize test efficiency.',
        },
        {
          heading: 'End-to-End Traceability',
          info: 'Integrated dashboards provide seamless tracking from requirements to defects.',
        },
        {
          heading: 'Faster Defect Resolution',
          info: 'Leverage auto-association and actionable insights to speed up defect resolution.',
        },
      ],
    },
    {
      image: section5,
      position: 'left',
      heading: 'Features That Redefine Test Management',
      info: 'Discover the key features that make GAINSS the ultimate test management tool.',
      lists: [
        {
          heading: 'AI-Powered Recommendations',
          info: 'Intelligent suggestions for test case design and execution planning.',
        },
        {
          heading: 'Advanced Reporting Dashboards',
          info: 'Real-time data for test execution, defect trends, and quality metrics.',
        },
        {
          heading: 'Automation-First Approach',
          info: 'API-driven integrations with your favorite automation frameworks for instant result updates.',
        },
        {
          heading: 'Localization Support',
          info: 'Simplified planning and execution for multi-language and region-specific testing.',
        },
        {
          heading: 'Device, OS, and Browser Matrix',
          info: 'Plan and execute across diverse configurations effortlessly.',
        },
        {
          heading: 'Defect Auto-Association',
          info: 'Shorten failure analysis with defects auto-linked to test cases.',
        },
      ],
    },
  ],
  getStartedSection: {
    title: 'Why GAINSS is the AI-Native Solution Your Team Needs',
    subtitle: 'AI at the Core of Every Feature',
    description:
      'Unlike legacy test management tools that bolt on AI as an afterthought, GAINSS is designed from the ground up as an AI-native platform. Every feature leverages machine learning to make your testing smarter, faster, and more impactful.',
    showButton: true,
  },
  formData: {
    reasonQuestion: 'What is your primary reason you are here?',
    reasonOptions: [
      'Looking for a test intelligence platform',
      'Identifying an alternative for Zephyr or TestRail',
    ],

    applicationQuestion: 'Which application are you looking to test?',
    applicationOptions: [
      'Mobile first',
      'Web only',
      'Web & Mobile',
      'Backend API or Microservices',
      'Data & AI',
      'Cloud Infrastructure',
      'SaaS Software',
    ],
  },
};

export default testingContent;
